<template>
  <section class="section has-background-light fullheight-min" @click="editedField = null">
    <div class="container">
      <slot></slot>
      <h2 class="title">
        <a href="#" @click.prevent="$router.go(-1)" title="назад">
          <span class="icon" style="margin-right:0.5em;"><i class="fas fa-arrow-circle-left"></i></span>
        </a>
        Просмотр {{$tc($route.params.model, 2)}}
      </h2>
      <div class="subheader">
        Поля, отмеченные <strong class="has-text-info">синим</strong> цветом можно редактировать двойным нажатием
      </div>
        <table class="table borderless is-hoverable transparent"  >
          <tbody>
            <tr v-for="(row, field) in pk" :key="field">
              <th :class="(field.split('.')[1] || field) in flatDoc(errors) ? 'has-text-danger' : ''">{{$tc(field.split('.')[1] || field)}}</th>
              <td
                @dblclick.stop="openInput(field)"
                :class="field in fields && !fields[field].read_only ? `has-text-info` : ''"
                :title="field in fields && !fields[field].read_only ? 'Редактировать двойным нажатием' : ''"
              >
                <!-- если поле в режиме редактирования -->
                <template v-if="editedField === field ">
                  <InputField
                    :field="fields[field]"
                    :finput.sync="pk[field]"
                    :info="fields[field] && fields[field].help_text"
                    :error="errors[field]"
                    :iclass="`is-small`"
                    @clicked.stop
                    :autocomplete="fields[field].type === 'primarykey'"
                  ></InputField>
                </template>

                <!-- если поле в режиме показа -->
                <template v-else >

                  <!-- если поле - массив -->
                  <div class="tags" v-if="Array.isArray(row)" style="float:left;margin-bottom:-.5rem;">
                    <span class="tag" v-for="(item, index) in row" :key="index">{{item.__str__ || item.title || item.name || item.pk || item.id || item}}</span>
                    <span v-if="!row.length">-</span>
                  </div>

                  <!-- если поле булевого типа показываем свитч -->
                  <template v-else-if="$_.isBoolean(row)">
                    <input type="checkbox" class="switch is-rounded is-small" :checked="row">
                    <label for=""></label>
                  </template>

                  <!-- если тип поля - primarykey - ссылка на связанный объект -->
                  <template v-else-if="$_.isObject(row)">
                    <router-link
                      :to="`/dashboard/${row.app}/${(row.model || field.split('.')[1] || field ).replace('_', '')}/${row.id || row.pk}`"
                      @click.stop
                    >
                      <i class="fas fa-link  has-text-grey"></i>
                    </router-link>
                    {{row['__str__'] || row.title || row.name || row.pk || row}}
                  </template>

                  <!-- поле в остальных случаях дата или строка или число -->
                  <span v-else >{{
                    row && field.includes('date') ? $moment(row).format('LLL') : typeof row === 'string' ? $tc(row, 1) : row
                    || '-'}}
                  </span>
                </template>

                <!-- кнопка вернуть значение поля -->
                <button
                  class="undo is-warning is-light"
                  style="margin-left:.5rem;"
                  title="отменить изменения"
                  @click.stop="pk[field] = pk_init[field]"
                  v-if="!$_.isEqual(pk[field], pk_init[field]) && editedField !== field"
                  :disabled="loading"
                >
                  <span class="icon"><i class="fas fa-undo "></i></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      <!-- кнопки действия, активны, если есть изменения -->
      <div class="buttons" >
        <template v-if="!$_.isEqual(pk, pk_init)">
          <button class="button is-info is-outlined" @click="pk = $_.merge({}, pk_init)" >Отменить</button>
          <button class="button is-warning" @click.stop="save">Сохранить</button>
        </template>
        <button class="button is-primary" @click.stop="sign">Подписать</button>
      </div>

      <!-- подсказка при сохранении -->
      <transition-group enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"  >
        <div :class="`notification ${status.class}`" v-for="(status, key, id) in statuses" :key="key" :id="key+id">
          <button class="delete" @click="$delete(statuses, key)"></button>
          <div v-html="status.message">
          </div>
        </div>
      </transition-group>
    </div>
  </section>
</template>
<script>
export default {
  components: {
    InputField: () => import('@/components/Input.vue')
  },
  data () {
    return {
      pk: {},
      pk_init: {},
      editedField: null,
      changedValues: {},
      fields: {},
      errors: {},
      statuses: {},
      loading: false,
      hideFields: ['__str__', 'id', 'pk', 'meta', 'app', 'model']
    }
  },
  created () {
    this.getData(this.$route.params)
    this.getOptions(this.$route.params)
  },
  beforeRouteUpdate (to, from, next) {
    this.getData(to.params)
    this.getOptions(to.params)
    next()
  },
  methods: {
    openInput (field) {
      // проверяет если поле объекта можно редактировать (не read_only) и устанавливает редактируемое поле
      const canEdit = field in this.fields ? this.fields[field].read_only : !(field in this.fields)
      if (canEdit) return
      this.editedField = field
    },
    setStatus (status, timeMs) {
      // на время устанавливает статус
      const id = this.$uuid()
      this.$set(this.statuses, id, status)
      setTimeout(() => this.$delete(this.statuses, id), timeMs)
    },
    sign () {
      // подписыввает документ
      this.loading = true
      const params = this.$route.params
      const url = `${params.app}/${params.model}/${params.pk}/sign/`
      this.$axios.post(url, null, { headers: this.$store.state.user.axiosHeaders })
        .then(res => {
          console.log(res)
          this.getData(params)
          this.loading = false
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.errors = err.response.data
          }
          const icon = '<span class="icon"><i class="fas fa-exclamation-triangle"></i></span>'
          this.setStatus({
            class: 'is-danger',
            message:
              '<p>Ошибка: не сохранено</p>' +
              `${'document' in err.response.data ? '<p>' + icon + err.response.data.document + '</p>' : ''}`
          }, 3500)
          this.loading = false
        })
    },
    save () {
      // сохраняет изменения на сервере
      this.loading = true
      const params = this.$route.params
      const url = `${params.app}/${params.model}/${params.pk}/`
      this.errors = {}
      // оставляем только измененные поля
      // вычисляем разницу
      let data = this.$_.differenceBy(Object.entries(this.pk), Object.entries(this.pk_init), 1)
      // преобразуем полученный массив в объект
      data = Object.fromEntries(new Map(data))

      // преобразуем поля, содержащие объекты в простые поля с pk или id,
      data = this.$_.mapValues(data, val => {
        if (this.$_.isObject(val)) return val.pk || val.id
        return val
      })

      // собираем поля содержащие "." в объект под именем слева от "."
      data = this.$_.transform(data, (result, value, key) => {
        const splittedKey = key.split('.')
        if (splittedKey[1]) {
          if (!(splittedKey[0] in result)) result[splittedKey[0]] = {}
          result[splittedKey[0]][splittedKey[1]] = value
        } else result[key] = value
        return result
      }, {})

      // отправляем
      this.$axios.patch(url, data, { headers: this.$store.state.user.axiosHeaders })
        .then(res => {
          if (res.status === 200) {
            // успех
            this.editedField = null
            this.getData(params)
            this.setStatus({
              class: 'is-success',
              message: 'Данные успешно сохранены'
            }, 3500)
          } else {
            this.setStatus({
              class: 'is-danger',
              message: 'Ошибка: не сохранено'
            }, 3500)
          }
          this.loading = false
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.errors = err.response.data
          }
          const icon = '<span class="icon"><i class="fas fa-exclamation-triangle"></i></span>'
          this.setStatus({
            class: 'is-danger',
            message:
              '<p>Ошибка: не сохранено</p>' +
              `${'detail' in err.response.data ? '<p>' + icon + err.response.data.detail + '</p>' : ''}`
          }, 3500)
          this.loading = false
        })
    },
    flatDoc (obj) {
      // делает вложенный объект document в один уровень с родительским объектом
      for (const [key, field] of Object.entries(obj)) {
        if (['document'].includes(key)) {
          delete obj[key]
          for (const key1 in field.children || field) {
            // убираем поля которые не нужно показывать
            if (this.hideFields.includes(key1)) continue
            obj[`${key}.${key1}`] = 'children' in field ? field.children[key1] : field[key1]
          }
        } else obj[key] = field
      }
      return obj
    },
    getOptions (params) {
      // получает типы полей объекта
      try {
        this.fields = {}
        const url = `${params.app}/${params.model}/${params.pk}/`
        console.log(url)
        this.$axios.options(url, { headers: this.$store.state.user.axiosHeaders })
          .then(res => {
            try {
              this.fields = this.flatDoc(res.data.actions.OPTIONS) || {}
            } catch (error) {
              throw new Error('нет прав на редактирование')
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    getData (params) {
      // получает объект
      this.pk = {}
      this.pk_init = {}
      try {
        const url = `${params.app}/${params.model}/${params.pk}/`
        this.$axios.get(url, { headers: this.$store.state.user.axiosHeaders })
          .then(res => {
            // убираем поля которые не нужно показывать
            this.hideFields.forEach(key => {
              if (key in res.data) delete res.data[key]
            })
            this.pk_init = this.flatDoc(res.data)
            this.pk = this.$_.merge({}, this.pk_init)
          })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
